import request from "@/utils/request";

/**
 * 密码登录
 * @param {Object} data
 * @param {string} data.phoneNumber - 手机号
 * @param {string} data.password - 密码
 */
export function loginByPass(data) {
  return request({
    url: "/loginByPass",
    method: "post",
    data,
  });
}

/**
 * 验证码登录
 * @param {Object} data
 * @param {string} data.phoneNumber - 手机号
 * @param {string} data.verCode - 验证码
 */
export function loginByVerCode(data) {
  return request({
    url: "/loginByVerCode",
    method: "post",
    data,
  });
}

/**
 * 忘记密码
 * @param {Object} data
 * @param {string} data.phoneNumber - 手机号
 * @param {string} data.verCode - 验证码
 * @param {string} data.password - 新密码
 */
export function forgetPass(data) {
  return request({
    url: "/forgetPass",
    method: "post",
    data,
  });
}

/**
 * 登录（旧接口，保留兼容）
 */
export function login(data) {
  return request({
    url: "/prod-api/login",
    method: "post",
    data,
  });
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  return request({
    url: "/prod-api/user/info",
    method: "get",
  });
}

/**
 * 退出登录
 */
export function logout() {
  return request({
    url: "/prod-api/logout",
    method: "post",
  });
}

/**
 * 修改密码
 * @param {Object} data
 * @param {string} data.oldPass - 旧密码
 * @param {string} data.newPass - /新密码
 */
export function updatePass(data) {
  return request({
    url: "/updatePass",
    method: "post",
    data,
  });
}
